export const NUM_DISPLAYED_ITEMS = 5.5;
